export const normalizeReviewContent = (value = "") =>
  value.trim().replace(/\s+/g, " ").toLowerCase();

export const isDuplicateReviewContent = ({
  reviews = [],
  userId,
  content,
  excludeReviewId = null,
}) => {
  const normalizedContent = normalizeReviewContent(content);

  if (!userId || !normalizedContent) {
    return false;
  }

  return reviews.some((review) => {
    const sameUser = String(review?.user?._id) === String(userId);
    const notExcluded = excludeReviewId ? String(review?._id) !== String(excludeReviewId) : true;
    return sameUser && notExcluded && normalizeReviewContent(review?.content) === normalizedContent;
  });
};
